import type { CSSProperties } from 'react';

interface Props {
  fileName: string;
  size?: string;
  onRemove?: () => void;
}

export default function AttachmentPreview({ fileName, size, onRemove }: Props) {
  return (
    <div style={wrap}>
      <span>📄</span>
      <span style={name}>{fileName}</span>
      {size && <span style={{ color: '#94a3b8' }}>{size}</span>}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          title="Quitar"
          style={removeBtn}
        >✕</button>
      )}
    </div>
  );
}

const wrap: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  background: '#f1f5f9',
  border: '1px solid #e2e8f0',
  borderRadius: 8,
  padding: '6px 10px',
  fontSize: 12,
  color: '#0f172a',
  maxWidth: 240,
};

const name: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 500,
};

const removeBtn: CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#94a3b8',
  cursor: 'pointer',
  padding: 0,
  fontSize: 14,
};
